export default function transform(data) {
  switch (data.orderBy) {
    case 'reference':
      data.orderBy = 'codeRefEXterne';
      break;
    case 'listeIntervenants':
      data.orderBy = 'payeur';
      break;
    case 'commandeVenteExterne':
      data.orderBy = 'referenceExterne1.code';
      break;
    case 'factureVenteExterne':
      data.orderBy = 'referenceExterne2.code';
      break;
    case 'planMedia':
      data.orderBy = 'devisCommande.planMedia.code';
      break;
    case 'referenceEtat':
      data.orderBy = 'etatRefExterne';
      break;
    case 'remiseBancaireExterne':
      data.orderBy = 'codeRemiseBancaire';
      break;
    default:
      data.orderBy = 'dateDevisCommande';
      break;
  }
  return data;
}
